import styled, { keyframes } from "styled-components";
import { breakpoints } from "../../../globalStyles";

export const fade = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const PodcastImageWrapper = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
  }
`;

export const PodcastActions = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 24px 16px;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.1s ease;

  @media ${breakpoints.lg} {
    padding: 18px 10px;
  }

  @media ${breakpoints.sm} {
    padding: 12px 8px;
  }

  button {
    background-color: var(--card-hover);
    border-radius: 100%;
    padding: 19px;

    &:hover {
      opacity: 0.8;
      transform: scale(1);
    }

    @media ${breakpoints.lg} {
      padding: 14px;
    }

    @media ${breakpoints.sm} {
      padding: 11px;
    }
  }

  img {
    width: 25px;

    @media ${breakpoints.lg} {
      width: 20px;
    }

    @media ${breakpoints.sm} {
      width: 14px;
    }
  }
`;

export const PodcastImage = styled.img`
  aspect-ratio: 1/1;
  width: 100%;
  transition: transform 0.3s ease;
  object-fit: cover;
`;

export const PodcastCard = styled.li`
  max-width: 154px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  opacity: 0;
  animation: ${fade} ${(props) => props.duration + "ms"} forwards;
  animation-timing-function: cubic-bezier(0 0 0.58 1);
  animation-delay: 100ms;
  cursor: pointer;

  @media (min-width: 360px) {
    max-width: 200px;
  }

  @media (min-width: 900px) {
    max-width: 285px;
  }

  &:hover {
    ${PodcastImageWrapper} {
      &::before {
        opacity: 1;
        transition: opacity 0.1s ease;
      }
    }
    ${PodcastActions} {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.1s ease;
    }
    ${PodcastImage} {
      transform: scale(1.05);
    }
  }
`;

export const PodcastTitle = styled.h4`
  margin: 4px 0 4px 0;
  line-height: 120%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const PodcastInfo = styled.div`
  color: #ffffff;
  display: flex;
  align-items: stretch;
  gap: 4px;
  line-height: normal;
  white-space: nowrap;

  @media (max-width: 1252px) {
    p {
      font-size: 14px;
    }
  }

  @media (max-width: 420px) {
    display: none;
  }
`;

export const PodcastRatingStar = styled.img`
  margin-right: 4px;

  @media ${breakpoints.md} {
    width: 16px;
  }
`;

export const PodcastDescription = styled.p`
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const LiveFlag = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 10px 24px;
  border: 1px solid var(--card-default);

  span {
    color: var(--background-primary);
    line-height: normal;
  }
`;

export const DetailInfoButton = styled.button`
  @media (max-width: 899px) {
    width: 36px;
    height: 36px;
  }
`;
